import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { APPConfig } from 'config/appConfig'
import {
  customerContainer,
  cartContainer,
  subscriptionContainer,
} from 'src/models'
import isArray from 'lodash/isArray'
import { Button } from 'react-bootstrap'
import { pageNames } from 'src/routes/pathParams'
import { Link } from 'react-router-dom'
import {
  i18nTranslate,
  getLocalStorage,
  setLocalStorage,
  deleteFromLocalStorage,
  trackGTMEvents,
  trackSubscriptionOrderNowGTMData,
  getMonthStringList,
} from 'src/utils'
import {
  getSubscriptionOrderSuccessDatesOfAllMonth,
  getAllSubscriptionProcessingDatesOfMonthLimit,
  getPastSubscriptionNonProcessedDates,
  getMinAvailableDateV2,
  getMinDateDetailsToBeSelectedV2,
  getMaxDateDetailsToBeSelectedV2,
  getNonProcessedSubscriptionDates,
  getFutureSubscriptionDates,
  getUniqueSubscriptionDatesOfMonthLimit,
  isToShowTwoMonthCalender,
} from 'src/deps'
import { ProductsPlaceHolder } from 'src/views/placeholders/ProductsPlaceHolder'
import {
  ShippingAddress,
  ShippingPayment,
  ShippingMethod,
  SubscriptionSchedule,
  SubscriptionNextOrders,
} from 'src/views/components/FlexibleSubscription'
import { toastState, overlayState } from 'src/views/components'
import { SubscriptionTabs } from 'src/views/components/SubscriptionComponents/SubscriptionTabs'
import { SubscriptionErrorNotification } from './SubscriptionErrorNotification'
import MetaDecorator from 'src/views/components/MetaDecorator'
import productSpillImg from 'src/images/No-Spill.png'
import { LoyaltyMFEContainer } from 'src/views/components/LoyaltyMFE/LoyaltyMFEContainer'
import { scrollUtilities } from 'src/utils/customScrollManager'
import { getPOLandingUrl } from 'src/utils/personalOfferUtils'
import './styles.scss'

@observer
class FlexibleSubscriptions extends React.Component {
  @observable subscriptionActiveTab = 'schedule'
  @observable isCancelSubsCallInProgress = false
  @observable processNowClicked = false
  @observable uniqueSubscriptionDatesOfMonthLimit = []
  @observable availableSubscriptionDatesOfMonthLimit = []
  @observable isUpcomingOrderDatesPrepared = false
  @observable isToRenderDataInNextOrderTab = false
  @observable isLoading = true
  currentTime = ''
  alreadyProcessedOrderDates = []
  minDateDetails = {}
  maxDateDetails = {}
  constructor(props) {
    super(props)
    subscriptionContainer.setIsPreferenceCallOver(false)
    subscriptionContainer.isPreferenceAPIInProgress = true
    subscriptionContainer.subscriptionPreferenceResponse = ''
    subscriptionContainer.showAllSubscriptionResponse = ''
    subscriptionContainer.selectedSubscription = ''
    subscriptionContainer.selectedMonth = ''
    this.subscriptionActiveTab =
      getLocalStorage('subscriptionActiveTab') || 'schedule'
  }

  async componentDidMount() {
    this.isLoading = true
    await this.getSubscriptionResponse(true)
    await this.initializeCSMSubscriptionData()
    this.isLoading = false
    scrollUtilities.scrollToTop('my-account-details-wrapper')
  }

  initializeCSMSubscriptionData = async () => {
    const customerResponse =
      customerContainer?.profileResponse?.customer ||
      customerContainer?.profileResponse
    const accountsTypes = ['Preferred Customer/Member', 'Retail Customer']
    if (customerResponse?.id) {
      if (
        accountsTypes?.includes(
          customerContainer.profileResponse?.accounts?.type
        ) &&
        subscriptionContainer?.showAllSubscriptionResponse?.length > 0
      ) {
        await subscriptionContainer.getCSMSubscriptionData()
      }
    } else {
      setTimeout(() => {
        this.initializeCSMSubscriptionData()
      }, 300)
    }
  }

  /**
   * Retrieves subscription data for the logged in user from the API.
   *
   * Checks if user is registered, gets subscription count from cart if true.
   * Gets all subscriptions for user from subscription API.
   */
  getSubscriptionResponse = async (isFromDidMount = false) => {
    const showAll = this.subscriptionActiveTab === 'schedule' || false
    console.log('...log....', customerContainer.userId)
    if (customerContainer.userId) {
      // const subscriptionMonth = showAll ? '' : new Date().getMonth() + 1

      /* getSubscriptionCount call is made from header and cart
       * so call is not required here when made from didMount
       */
      if (customerContainer.isRegisterUser && !isFromDidMount) {
        await cartContainer.getSubscriptionCount()
      }
      const response =
        await subscriptionContainer.getAllSubscriptionsPreference(
          customerContainer.userId,
          '',
          true
        )
      this.uniqueSubscriptionDatesOfMonthLimit = []
      this.availableSubscriptionDatesOfMonthLimit = []
      this.alreadyProcessedOrderDates = []
      await this.getUpComingOrders()
      if (this.subscriptionActiveTab === 'nextOrder') {
        this.isToRenderDataInNextOrderTab = true
        this.currentTime = new Date().getTime()
      }
    } else {
      setTimeout(() => {
        this.getSubscriptionResponse(isFromDidMount)
      }, 500)
    }
  }

  getUpComingOrders = () => {
    this.isUpcomingOrderDatesPrepared = false
    const isToShowTwoMonthProcessingDates = isToShowTwoMonthCalender() || false
    const subscriptionsResponse =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.selectedSubscriptions || []
    const alreadyProcessedSubscriptionDates =
      getSubscriptionOrderSuccessDatesOfAllMonth(subscriptionsResponse) || []
    this.alreadyProcessedOrderDates = alreadyProcessedSubscriptionDates
    this.minDateDetails = getMinDateDetailsToBeSelectedV2() || {}
    this.maxDateDetails =
      getMaxDateDetailsToBeSelectedV2(alreadyProcessedSubscriptionDates) || {}
    const allSubscriptionDatesOfTwoMonthLimit =
      getAllSubscriptionProcessingDatesOfMonthLimit(
        subscriptionsResponse,
        this.minDateDetails,
        this.maxDateDetails
      ) || []
    const nonProcessedSubscriptionDatesOfMonthLimit =
      getNonProcessedSubscriptionDates(
        alreadyProcessedSubscriptionDates,
        allSubscriptionDatesOfTwoMonthLimit
      ) || []
    const uniqueSubscriptionDatesOfMonthLimit =
      getUniqueSubscriptionDatesOfMonthLimit(
        nonProcessedSubscriptionDatesOfMonthLimit
      ) || []
    this.uniqueSubscriptionDatesOfMonthLimit =
      uniqueSubscriptionDatesOfMonthLimit
    this.availableSubscriptionDatesOfMonthLimit =
      isToShowTwoMonthProcessingDates
        ? nonProcessedSubscriptionDatesOfMonthLimit
        : uniqueSubscriptionDatesOfMonthLimit
    this.isUpcomingOrderDatesPrepared = true
  }

  handleSkipShipment = async (date, isSkipped, month = '') => {
    const postData = {
      preferenceProperties: [
        {
          name: 'isSkipped',
          orderProcessingDate: date,
          value: isSkipped,
        },
        {
          name: 'month',
          orderProcessingDate: date,
          value: month,
        },
      ],
    }
    overlayState.toggleLoader()
    const response = await subscriptionContainer.updateSubscriptionsPreference(
      customerContainer.userId,
      postData
    )
    if (subscriptionContainer.isSuccessResponse(response)) {
      await this.getSubscriptionResponse()
      await subscriptionContainer.getCSMSubscriptionData()
      const successMessage = isSkipped
        ? i18nTranslate(
            'skipSubscription.skipmentSkipSubscribe',
            'Your shipment has been skipped'
          )
        : i18nTranslate(
            'skipSubscription.skipmentUnSkipSubscribe',
            'Your shipment has been Unskipped'
          )
      toastState.setToastMessage(successMessage, true)
    }
    overlayState.toggleLoader()
  }

  handleProcessingNow = async (date, reprocessNow = false) => {
    this.processNowClicked = true
    /* const selectedMonth = 
      subscriptionContainer.subscriptionPreferenceResponse?.
      selectedSubscriptions?.[0]?.selectedMonth ||
      0
     */
    overlayState.toggleLoader()
    const response =
      await subscriptionContainer.updateProcessingNowSubscriptions(
        customerContainer.userId,
        {
          isApplyStoreCredit: false,
          runWithPVAssist: true,
          reprocessNow: false,
        },
        date
      )
    subscriptionContainer.subscriptionSelectedDate = ''
    deleteFromLocalStorage('subscriptionNextOrderSelectedDate')
    await this.getSubscriptionResponse()
    if (subscriptionContainer.isSuccessResponse(response)) {
      let orderId =
        response?.cartDetails?.[0]?.orderId ||
        response?.cartDetails?.[1]?.orderId ||
        ''

      // await this.getSubscriptionResponse()

      /* CX121-4495 - same old i18n key,but new value  - Google Translated*/
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.orderCreated',
          'Your order has been placed. You will receive an email confirmation shortly.'
        ),
        true
      )
      await subscriptionContainer.getCSMSubscriptionData()
      const subscriptionPreferenceResponse =
        subscriptionContainer.subscriptionPreferenceResponse || {}
      trackSubscriptionOrderNowGTMData({
        orderId: orderId,
        ...subscriptionPreferenceResponse,
      })
    } else {
      const isServiceFailure = response?.isServiceFailure || false
      const processNowResponse = response?.errors?.[0]?.message || ''
      let errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : processNowResponse === 'REQUIRED_NOTNULL'
          ? i18nTranslate(
              'order.submitPhoneError',
              'Missing information for selected address, Please update before moving forward.'
            )
          : response?.message ||
            response?.errorMessage ||
            i18nTranslate(
              'subscription.failure',
              'Sorry, we are unable to update your subscription. Please try again.'
            )
      toastState.setToastMessage(errorMessage, false)
    }
    overlayState.toggleLoader()
    this.processNowClicked = false
  }

  handleProductEdit = async (
    product,
    frequencyData,
    count,
    isOnetime = false,
    nextProcessingDate,
    convertToSub = false,
    isReloadRequired = false,
    isFrom = '',
    selectedMonth,
    previousDateAvailable = false
  ) => {
    const { id = '' } = product
    const isToShowTwoMonthProcessingDates = isToShowTwoMonthCalender()
    const month = this.props.location?.queryParams?.month || ''
    overlayState.toggleLoader()
    let orderType =
      isOnetime === true ? 'VARIABLE_SINGLE_ORDER' : 'VARIABLE_MULTI_ORDER'
    let productInfo = {}
    let monthNumber = getMonthStringList()[selectedMonth - 1]
    let selectedDate = `${monthNumber} ${nextProcessingDate}`
    if (isFrom === 'dateChange') {
      productInfo = {
        recurrenceOrderProcessingDate: nextProcessingDate,
        month: selectedMonth,
      }
    } else if (isFrom === 'frequencyChange') {
      productInfo = {
        frequencyType: frequencyData?.frequencyType,
        frequencyPeriod: parseInt(frequencyData?.frequencyPeriod),
        type: orderType,
      }
    } else if (isFrom === 'quantityAndDate') {
      productInfo = {
        recurrenceOrderProcessingDate: nextProcessingDate,
        month: selectedMonth,
        ...(count && {
          itemInfo: [
            {
              quantity: count,
            },
          ],
        }),
      }
    } else if (isFrom === 'quantityAndFrequency') {
      productInfo = {
        frequencyType: frequencyData?.frequencyType,
        frequencyPeriod: parseInt(frequencyData?.frequencyPeriod),
        type: orderType,
        ...(count && {
          itemInfo: [
            {
              quantity: count,
            },
          ],
        }),
      }
    } else if (isFrom === 'dateAndFrequency') {
      productInfo = {
        frequencyType: frequencyData?.frequencyType,
        frequencyPeriod: parseInt(frequencyData?.frequencyPeriod),
        type: orderType,
        recurrenceOrderProcessingDate: nextProcessingDate,
        month: selectedMonth,
      }
    } else if (isFrom === 'quantityChange') {
      productInfo = {
        ...(count && {
          itemInfo: [
            {
              quantity: count,
            },
          ],
        }),
      }
    } else {
      productInfo = {
        frequencyType: frequencyData?.frequencyType,
        frequencyPeriod: parseInt(frequencyData?.frequencyPeriod),
        recurrenceOrderProcessingDate: nextProcessingDate,
        month: selectedMonth,
        type: orderType,
        ...(count && {
          itemInfo: [
            {
              quantity: count,
            },
          ],
        }),
      }
    }
    const response = await subscriptionContainer.updateSubscription(
      {
        subscriptionId: id,
        patchProperties: {
          id: id,
          ...productInfo,
        },
      },
      { userId: customerContainer.userId, month: month }
    )
    // if (this.subscriptionActiveTab === 'schedule' || isReloadRequired) {
    // }
    if (previousDateAvailable && isToShowTwoMonthProcessingDates) {
      deleteFromLocalStorage('subscriptionNextOrderSelectedDate')
      this.handleTabChange('schedule')
      setLocalStorage('scheduleOrderSelectedDate', selectedDate)
    } else {
      await this.getSubscriptionResponse()
    }
    overlayState.toggleLoader()
    if (subscriptionContainer.isSuccessResponse(response)) {
      // Successful monthly sub to One-time sub message
      if (isOnetime && isFrom === 'frequencyChange') {
        toastState.setToastMessage(
          i18nTranslate(
            'subscription.successItemOneTime',
            'Item will only ship once with next shipment. Shipment must include subscribed items in order to process.'
          ),
          true
        )
      } else if (convertToSub) {
        toastState.setToastMessage(
          i18nTranslate(
            'subscription.movedToSubscription',
            'Item successfully added to subscription.'
          ),
          true
        )
        await subscriptionContainer.getCSMSubscriptionData()
      } else if (
        (isFrom === 'dateChange' ||
          isFrom === 'quantityAndDate' ||
          isFrom === 'all' ||
          isFrom === 'dateAndFrequency') &&
        this.subscriptionActiveTab === 'schedule' &&
        isToShowTwoMonthProcessingDates
      ) {
        toastState.setToastMessage(
          i18nTranslate(
            'subscription.updateSuccess',
            'Your subscription has been updated.'
          ),
          true
        )
        await subscriptionContainer.getCSMSubscriptionData()
        if (
          this.uniqueSubscriptionDatesOfMonthLimit?.some(
            date =>
              date.getDate() === nextProcessingDate &&
              date.getMonth() + 1 === selectedMonth
          )
        ) {
          subscriptionContainer.subscriptionSelectedDate = selectedDate
          setLocalStorage('subscriptionNextOrderSelectedDate', selectedDate)
          this.handleTabChange('nextOrder')
        }
      } else {
        toastState.setToastMessage(
          i18nTranslate(
            'subscription.updateSuccess',
            'Your subscription has been updated.'
          ),
          true
        )
        await subscriptionContainer.getCSMSubscriptionData()
      }
      return true
    } else {
      if (!isReloadRequired) {
        overlayState.toggleLoader()
        await this.getSubscriptionResponse()
        overlayState.toggleLoader()
      }
      const isServiceFailure = response?.isServiceFailure || false
      const errorCode = response?.responseCode || response?.code || ''
      const editFreezeErrorCode =
        errorCode === 'error.subscription.editfreeze.date.reached'
      const errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : editFreezeErrorCode
          ? i18nTranslate(
              'subscription.editFreezeErrorMessage',
              'This Subscription order is currently being processed and at this time no changes will be allowed. Please return after your Subscription order has shipped to make any changes to your next order.'
            )
          : (response && response.message) ||
            i18nTranslate(
              'subscription.failure',
              'Sorry, we are unable to update your subscription. Please try again.'
            )
      toastState.setToastMessage(errorMessage, false)
      return false
    }
  }

  handleSkipItem = async (data, selectedMonth) => {
    const { id, isSkippedSubscription } = data
    overlayState.toggleLoader()
    const response = await subscriptionContainer.skipSubscription({
      subscriptionId: id,
      isSkippedSubscription: isSkippedSubscription,
      selectedMonth,
    })
    if (subscriptionContainer.isSuccessResponse(response)) {
      await this.getSubscriptionResponse()
      await subscriptionContainer.getCSMSubscriptionData()
      const successMessage = isSkippedSubscription
        ? i18nTranslate(
            'editSubscription.skipSubscribe',
            'Your upcoming or next month delivery has been skipped successfully'
          )
        : i18nTranslate(
            'editSubscription.unSkipSubscribe',
            'Your upcoming or next month delivery has been unskipped successfully'
          )
      toastState.setToastMessage(successMessage, true)
    } else {
      const isServiceFailure = response?.isServiceFailure || false
      const errorCode = response?.responseCode || response?.code || ''
      const editFreezeErrorCode =
        errorCode === 'error.instance.unskip.date.reached'
      const errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : editFreezeErrorCode
          ? i18nTranslate(
              'subscription.editFreezeErrorMessage',
              ' This subscription order is currently being processed and at this time no changes will be allowed. Please return after your subscription order has shipped to make any changes to your next order.'
            )
          : (response && response.message) ||
            i18nTranslate(
              'subscription.failure',
              'Sorry, we are unable to update your subscription. Please try again.'
            )
      toastState.setToastMessage(errorMessage, false)
    }
    overlayState.toggleLoader()
  }

  cancelSubscription = async subscriptionId => {
    overlayState.toggleLoader()
    const response = await subscriptionContainer.updateSubscription(
      {
        subscriptionId,
        patchProperties: {
          status: 'CANCELED',
        },
      },
      true
    )
    if (subscriptionContainer.isSuccessResponse(response)) {
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.updateSuccess',
          'Your subscription has been updated.'
        ),
        true
      )
      await this.getSubscriptionResponse()
      await subscriptionContainer.getCSMSubscriptionData()
    } else {
      const isServiceFailure = response?.isServiceFailure || false
      const errorCode = response?.responseCode || response?.code || ''
      const editFreezeErrorCode =
        errorCode === 'error.subscription.editfreeze.date.reached'
      const errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : editFreezeErrorCode
          ? i18nTranslate(
              'subscription.editFreezeErrorMessage',
              'This Subscription order is currently being processed and at this time no changes will be allowed. Please return after your Subscription order has shipped to make any changes to your next order.'
            )
          : (response && response.message) ||
            i18nTranslate(
              'subscription.failure',
              'Sorry, we are unable to update your subscription. Please try again.'
            )
      toastState.setToastMessage(errorMessage, false)
    }
    overlayState.toggleLoader()
  }

  addQuickSearchProduct = async (
    postData,
    isOneTime,
    previousDateAvailable,
    tabName
  ) => {
    overlayState.toggleLoader()
    const response = await subscriptionContainer.addToSubscription(postData)
    if (subscriptionContainer.isSuccessResponse(response)) {
      if (isOneTime) {
        toastState.setToastMessage(
          i18nTranslate(
            'subscription.successItemOneTime',
            'Item will only ship once with next shipment. Shipment must include subscribed items in order to process.'
          ),
          true
        )
      } else {
        toastState.setToastMessage(
          i18nTranslate(
            'subscription.successItem',
            'Item(s) successfully added to subscription'
          ),
          true
        )
        await subscriptionContainer.getCSMSubscriptionData()
      }
      const isToShowTwoMonthProcessingDates =
        isToShowTwoMonthCalender() || false
      if (previousDateAvailable && isToShowTwoMonthProcessingDates) {
        deleteFromLocalStorage('subscriptionNextOrderSelectedDate')
        this.handleTabChange('schedule')
        setLocalStorage('scheduleOrderSelectedDate', tabName)
      } else {
        await this.getSubscriptionResponse()
      }
    } else if (
      (response.code && response.code == 'YLSHIPPING_COMMON') ||
      (isArray(response.errors) &&
        response.errors[0].code == 'YLSHIPPING_COMMON')
    ) {
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.shippingRestriction',
          'This item has special shipping requirements. It has shipping restrictions and can not be shipped to your default address. Please change your shipping address.'
        ),
        false
      )
    } else if (response.code && response.code == 'EOGLOB0001') {
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.paymentIssue',
          'You currently do not have a payment method associated with subscriptions. Please add a payment method'
        )
      )
    } else if (response.code && response.code == 'YLUSSB015') {
      //TD-814
      const errorMessage = response?.responseMessage || response?.message || ''
      toastState.setToastMessage(errorMessage)
      await this.getSubscriptionResponse()
    } else if (response?.code && response.code == 'EOCA0000110') {
      cartContainer.isNotifyDirectSellerPopupOpen = true
      cartContainer.skuDetailsForNotifyDirectSeller = {
        productId: postData?.[0]?.productId,
        skuId: postData?.[0]?.skuId,
      }
    } else {
      const errorCode = response?.responseCode || response?.code || ''
      const editFreezeErrorCode =
        errorCode === 'error.subscription.editfreeze.date.reached'
      const responseErrorMessage =
        response?.responseMessage || response?.message || ''
      const errorMessage = editFreezeErrorCode
        ? i18nTranslate(
            'subscription.editFreezeErrorMessage',
            'This subscription order is currently being processed and at this time no changes will be allowed. Please return after your subscription order has shipped to make any changes to your next order.'
          )
        : responseErrorMessage
      toastState.setToastMessage(errorMessage)
    }
    overlayState.toggleLoader()
  }

  cancelSubscriptionAll = async () => {
    const userId = customerContainer.userId || ''
    this.isCancelSubsCallInProgress = true
    overlayState.toggleLoader()
    const response = await subscriptionContainer.cancelAllSubscription(
      {
        userId: userId,
        patchProperties: {
          status: 'CANCELED',
        },
      },
      true
    )
    if (subscriptionContainer.isSuccessResponse(response)) {
      await this.getSubscriptionResponse()
      if (customerContainer.isRegisterUser)
        await cartContainer.getSubscriptionCount()
      toastState.setToastMessage(
        i18nTranslate(
          'subscription.updateSuccess',
          'Your subscription has been updated.'
        ),
        true
      )
      await subscriptionContainer.getCSMSubscriptionData()
    } else {
      await this.getSubscriptionResponse()
      const isServiceFailure = response?.isServiceFailure || false
      const errorCode = response?.responseCode || response?.code || ''
      const editFreezeErrorCode =
        errorCode === 'error.subscription.editfreeze.date.reached'
      const errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : editFreezeErrorCode
          ? i18nTranslate(
              'subscription.editFreezeErrorMessage',
              'This Subscription order is currently being processed and at this time no changes will be allowed. Please return after your Subscription order has shipped to make any changes to your next order.'
            )
          : (response && response.message) ||
            i18nTranslate(
              'subscription.failure',
              'Sorry, we are unable to update your subscription. Please try again.'
            )
      toastState.setToastMessage(errorMessage, false)
    }
    this.isCancelSubsCallInProgress = false
    overlayState.toggleLoader()
  }

  handleTabChange = tabName => {
    this.subscriptionActiveTab = tabName
    if (tabName !== 'nextOrder') {
      deleteFromLocalStorage('subscriptionNextOrderSelectedDate')
      subscriptionContainer.subscriptionSelectedDate = ''
    }
    setLocalStorage('subscriptionActiveTab', tabName)
    trackGTMEvents({
      event: 'subscriptionProfile',
      type: tabName === 'schedule' ? 'subscription schedule' : 'next orders',
    })
  }

  getDateDetails = () => {
    const nonProcessedPastSubscriptionDates =
      getPastSubscriptionNonProcessedDates(
        this.availableSubscriptionDatesOfMonthLimit,
        this.minDateDetails
      ) || []
    const nonProcessedFutureSubscriptionDates =
      getFutureSubscriptionDates(
        this.availableSubscriptionDatesOfMonthLimit,
        this.minDateDetails
      ) || []
    const minDate = this.minDateDetails?.minFullDate || ''
    const availableMinDate =
      getMinAvailableDateV2(
        this.alreadyProcessedOrderDates,
        this.minDateDetails,
        this.maxDateDetails
      ) || ''
    const maxDate = this.maxDateDetails?.maxFullDate || ''
    const isToShowTwoMonthProcessingDates = isToShowTwoMonthCalender()
    const isToDisableCurrentMonthDatesInNextMonth =
      !isToShowTwoMonthProcessingDates

    return {
      nonProcessedPastSubscriptionDates,
      nonProcessedFutureSubscriptionDates,
      minDate,
      availableMinDate,
      maxDate,
      isToShowTwoMonthProcessingDates,
      isToDisableCurrentMonthDatesInNextMonth,
    }
  }

  renderSubscriptionSchedule = () => {
    const {
      nonProcessedPastSubscriptionDates = [],
      nonProcessedFutureSubscriptionDates = [],
      minDate = '',
      availableMinDate = '',
      maxDate = '',
      isToShowTwoMonthProcessingDates = false,
      isToDisableCurrentMonthDatesInNextMonth = false,
    } = this.getDateDetails()
    return (
      <SubscriptionSchedule
        handleTabChange={this.handleTabChange}
        handleCancelSingle={this.cancelSubscription}
        handleCancelItem={this.cancelSubscriptionAll}
        handleProductEdit={this.handleProductEdit}
        addQuickSearchProduct={this.addQuickSearchProduct}
        availableOrderDates={this.uniqueSubscriptionDatesOfMonthLimit}
        alreadyProcessedOrderDates={this.alreadyProcessedOrderDates}
        nonProcessedPastSubscriptionDates={nonProcessedPastSubscriptionDates}
        nonProcessedFutureSubscriptionDates={
          isToShowTwoMonthProcessingDates
            ? this.availableSubscriptionDatesOfMonthLimit
            : nonProcessedFutureSubscriptionDates
        }
        activeTab={this.subscriptionActiveTab}
        minDate={minDate}
        availableMinDate={availableMinDate}
        maxDate={maxDate}
        isToDisableCurrentMonthDatesInNextMonth={
          isToDisableCurrentMonthDatesInNextMonth
        }
        isToShowTwoMonthProcessingDates={isToShowTwoMonthProcessingDates}
        {...this.props}
      />
    )
  }

  renderSubscriptionNextOrders = () => {
    const {
      nonProcessedPastSubscriptionDates = [],
      nonProcessedFutureSubscriptionDates = [],
      minDate = '',
      availableMinDate = '',
      maxDate = '',
      isToShowTwoMonthProcessingDates = false,
      isToDisableCurrentMonthDatesInNextMonth = false,
    } = this.getDateDetails()

    return (
      <SubscriptionNextOrders
        subscriptionResponse={subscriptionContainer.showAllSubscriptionResponse}
        activeTab={this.subscriptionActiveTab}
        handleTabChange={this.handleTabChange}
        handleCancelItem={this.cancelSubscription}
        handleSkipItem={this.handleSkipItem}
        addQuickSearchProduct={this.addQuickSearchProduct}
        handleProductEdit={this.handleProductEdit}
        handleProcessingNow={this.handleProcessingNow}
        handleSkipShipment={this.handleSkipShipment}
        getUpComingOrders={this.getUpComingOrders}
        availableOrderDates={this.uniqueSubscriptionDatesOfMonthLimit}
        alreadyProcessedOrderDates={this.alreadyProcessedOrderDates}
        nonProcessedPastSubscriptionDates={nonProcessedPastSubscriptionDates}
        nonProcessedFutureSubscriptionDates={
          nonProcessedFutureSubscriptionDates
        }
        minDate={minDate}
        availableMinDate={availableMinDate}
        maxDate={maxDate}
        isToDisableCurrentMonthDatesInNextMonth={
          isToDisableCurrentMonthDatesInNextMonth
        }
        isToShowTwoMonthProcessingDates={isToShowTwoMonthProcessingDates}
        isToRenderDataInNextOrderTab={this.isToRenderDataInNextOrderTab}
        getAllSubscriptionLastCallTime={this.currentTime}
        {...this.props}></SubscriptionNextOrders>
    )
  }

  /**
   * Renders a message when no subscriptions are found for the user.
   * Shows text and a button to start shopping.
   */
  subscriptionNotFound = () => {
    // PO-only: `<Link to='/'>` resolves to basename + '/' (trailing slash)
    // and `<Link>`'s `to` object cannot suppress that slash. Use a plain
    // anchor + `history.pushState` + `popstate` so react-router updates
    // SPA-style without a hard reload while keeping the exact URL
    // `.../personal-offer/<sponsor>?pitchId=...` (no trailing slash).
    // `getPOLandingUrl()` returns null off PO so non-PO flow is unchanged.
    const poLandingUrl = getPOLandingUrl()
    const handlePOStartShoppingClick = e => {
      if (!poLandingUrl) return
      e.preventDefault()
      window.history.pushState({}, '', poLandingUrl)
      window.dispatchEvent(new PopStateEvent('popstate'))
    }
    return (
      <>
        <div className="d-flex no-subcription-container align-items-center justify-content-center m-auto h-50">
          <div className="p-3">
            <div className="no-subscription-image">
              <img height={'100%'} width={'100%'} src={productSpillImg} />
            </div>
          </div>
          <div className="p-3">
            <p className="no-subscription-text">
              {i18nTranslate(
                'mysubscriptions.noSubscriptionFound',
                'No Subscriptions Found'
              )}
            </p>
            {poLandingUrl ? (
              <a
                href={poLandingUrl}
                onClick={handlePOStartShoppingClick}
                className="d-flex justify-content-end">
                <Button
                  data-testid="qa-start-shopping"
                  className="text-uppercase subscriptionNotFound-btn">
                  {i18nTranslate('cart.startShopping', 'Start Shopping')}
                </Button>
              </a>
            ) : (
              <Link to={pageNames.home} className="d-flex justify-content-end">
                <Button
                  data-testid="qa-start-shopping"
                  className="text-uppercase subscriptionNotFound-btn">
                  {i18nTranslate('cart.startShopping', 'Start Shopping')}
                </Button>
              </Link>
            )}
          </div>
        </div>
      </>
    )
  }

  renderSubscription = () => {
    const showAllSubscriptionProducts =
      subscriptionContainer?.showAllSubscriptionResponse || []

    const titleText = i18nTranslate('subscription.header', 'Subscriptions')
    const isEnableSubscriptionMaintenance =
      APPConfig?.getAppConfig()?.enableSubscriptionMaintenance === 'true'
    const headerClass = isEnableSubscriptionMaintenance ? 'disabled' : ''
    const shouldRenderLoyaltyMFEContainer =
      showAllSubscriptionProducts?.length > 0
    return (
      <div>
        <h1 className="heading-1 subs-primary-title">{titleText}</h1>
        {isEnableSubscriptionMaintenance && (
          <div className="subscription-maintenance-message d-flex flex-column align-items-center justify-content-center">
            <div className="subscription-maintenance-header">
              {i18nTranslate(
                'subscription.maintenanceMessageHeader',
                'Temporarily down for maintenance.'
              )}
            </div>
            <div className="pt-2 pb-2 subscription-maintenance-details d-flex flex-column align-items-center justify-content-center">
              <p className="">
                {i18nTranslate(
                  'subscription.maintenanceMessageLine1',
                  'We are performing scheduled maintenance.'
                )}
              </p>
              <p className="pt-1">
                {i18nTranslate(
                  'subscription.maintenanceMessageLine2',
                  'We should be back online shortly.'
                )}
              </p>
            </div>
          </div>
        )}
        <div className={`subscription-details-section ${headerClass}`}>
          {showAllSubscriptionProducts?.length > 0 ? (
            <>
              {shouldRenderLoyaltyMFEContainer && (
                <LoyaltyMFEContainer
                  componentName="ProgressBar"
                  needMonthCompletionValueData={true}
                />
              )}
              <div className="shipping-details-wrapper flex-xl-row d-flex flex-lg-row flex-sm-column flex-column flex-md-row">
                <ShippingAddress
                  updateSubscription={this.getSubscriptionResponse}
                />
                <ShippingPayment
                  updateSubscription={this.getSubscriptionResponse}
                />
                <ShippingMethod
                  updateSubscription={this.getSubscriptionResponse}
                />
              </div>
              {subscriptionContainer.ccExpiryFlag && (
                <div className="mt-3">
                  <SubscriptionErrorNotification case="CCExpired" />
                </div>
              )}
              <div
                className="subscription-tabs"
                data-testid="qa-subscription-process-tabs-wrapper">
                <SubscriptionTabs
                  ScheduleTab={this.renderSubscriptionSchedule}
                  nextOrderTab={this.renderSubscriptionNextOrders}
                  handleTabChange={this.handleTabChange}
                  activeTab={this.subscriptionActiveTab}
                />
              </div>
            </>
          ) : (
            <>
              {this.subscriptionNotFound()}
              <LoyaltyMFEContainer componentName="RewardsBanner" />
            </>
          )}
        </div>
      </div>
    )
  }

  renderPlaceHolder = () => {
    const products = Array(6).fill('product')
    const listItems = Array(6).fill('listItem')
    const listBlocks = Array(3).fill('list')
    return (
      <div className="placholder-custom subscription-items-container">
        <div className="ph-search-block mx-3 my-2"></div>
        <div className="ph-options-block mx-3 mt-2 my-2"></div>
        <div className="subscription-items-placeholder">
          <ProductsPlaceHolder
            columnType={{ xs: '12', sm: '12', md: '4', lg: '4' }}
            columnClassName="subscription-items mb-2 mxsdf-2"
            products={products}
          />
          <div className="sidebar-isLoading">
            {listBlocks.length > 0 &&
              listBlocks.map((list, i) => (
                <div className="listBlock" key={i}>
                  <div className="d-flex justify-content-between mt-3 mb-3">
                    <p className="w-40"></p>
                    <p className="w-25"></p>
                  </div>
                  {/* <p className="w-50"></p> */}
                  <ul>
                    {listItems.length > 0 &&
                      listItems.map((listItem, i) => (
                        <li className="my-2" key={i}></li>
                      ))}
                  </ul>
                  {/* <p className="w-40 m-0"></p> */}
                </div>
              ))}
          </div>
        </div>
      </div>
    )
  }

  render() {
    const myAccountSubscription = i18nTranslate(
      'myAccountSubscriptionsPage.title',
      'Nu Skin | Subscriptions'
    )
    return (
      <>
        <MetaDecorator
          title={myAccountSubscription}
          imageUrl=""
          imageAlt=""
          description={myAccountSubscription}
          location={this.props}
        />
        <div className="flexible-subscription-container">
          {this.isLoading
            ? this.renderPlaceHolder() // Show loading placeholder
            : this.renderSubscription()}
        </div>
      </>
    )
  }
}
export default FlexibleSubscriptions
export { FlexibleSubscriptions }
